import { useState } from "react";
import { FullscreenTakeover } from "@jsq/ds/core";
import { ExtractedDataPreviewPanel } from "~/pages/Compliance/documents/ExtractedDataPreviewPanel";
import { ExitWarningModal } from "../../../../Common/ExitWarningModal";
import { useEntityClientWizard } from "../../context";
import { WizardFooterBar } from "../../WizardFooterBar";
import { EntityProfileForm } from "../EntityProfileForm";

interface Props {
  documentId: number;
  onBack: () => void;
}

export const ProfileExtractionPreview = ({ documentId, onBack }: Props) => {
  const { footerContent } = useEntityClientWizard();
  const [showExitWarning, setShowExitWarning] = useState(false);

  const requestExit = () => setShowExitWarning(true);

  return (
    <FullscreenTakeover>
      <FullscreenTakeover.Header title="Create profile from document" onExit={requestExit} />
      <ExtractedDataPreviewPanel documentId={documentId}>
        {(extractedData) => (
          <EntityProfileForm
            onBack={requestExit}
            extractedData={extractedData}
            documentId={documentId}
          />
        )}
      </ExtractedDataPreviewPanel>
      {footerContent && (
        <FullscreenTakeover.Footer>
          <WizardFooterBar>{footerContent}</WizardFooterBar>
        </FullscreenTakeover.Footer>
      )}
      <ExitWarningModal
        show={showExitWarning}
        onCancel={() => setShowExitWarning(false)}
        onConfirm={onBack}
      />
    </FullscreenTakeover>
  );
};
